/**
 * @file: ClientPlatformRefusalMiddleware.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { clientPlatformRefused$ } from '@euler/functions/entitlements/clientPlatformRefused';
import { ResponseContext } from '@euler/lib/request';
import { Middleware } from '@euler/lib/request/Middleware';

/** Notes the server refusing this build for the store. */
export class ClientPlatformRefusalMiddleware implements Middleware {
  async post(context: ResponseContext) {
    if (context.response.status !== 403) return;
    try {
      const body = await context.response.clone().json();
      if (body?.subCode === 'client_platform_not_enabled') {
        clientPlatformRefused$.next(true);
      }
    } catch {
      // not a JSON error body
    }
  }
}
